import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

export const MobileDetails = ({ id, label, children, className = "" }) => {
  const [open, setOpen] = useState(false);
  return <div className={`mobile-disclosure ${className}`} data-expanded={open} data-testid={`${id}-disclosure`}>
    <button type="button" className="mobile-disclosure-toggle" data-testid={`${id}-toggle`} aria-expanded={open} aria-controls={`${id}-content`} onClick={() => setOpen(value => !value)}><span>{label}</span><ChevronDown size={18} aria-hidden="true" /></button>
    <div className="mobile-disclosure-content" id={`${id}-content`} data-testid={`${id}-content`}>{children}</div>
  </div>;
};